// extracted by mini-css-extract-plugin
export default {"link":"style_link__-vBMG","underlined":"style_underlined__AVpfq","inherit":"style_inherit__2M9yf","disabled":"style_disabled__IER1I","circled":"style_circled__2Gbep"};